import classNames from 'classnames'
import { observer } from 'mobx-react'
import GlobalState, {
  changeMenuState,
  changeLocaleState,
  changeLocale,
} from '../../stores/GlobalState'
import './index.scss'
import { ReactComponent as Arrow } from '../../assets/arrow-left.svg'
import { useEffect } from 'react'
import ContentState from '../../stores/ContentState'
const LocaleMenu = observer(() => {
  const langs: any = ContentState.localeMenu

  useEffect(() => {
    if (GlobalState.isLocaleOpen) {
      document.querySelector('body, html, #root')?.classList.add('hidden-menu')
    } else
      document
        .querySelector('body, html, #root')
        ?.classList.remove('hidden-menu')
  }, [GlobalState.isLocaleOpen])
  if (!langs) return <></>

  return (
    <section
      className={classNames('menu locale', GlobalState.isLocaleOpen && 'open')}
      onClick={() => changeLocaleState()}
    >
      <div
        className="menu__container locale"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="menu__top">
          <div className="menu__top-left">
            <div
              className="menu__back"
              onClick={() => {
                changeLocaleState()
                changeMenuState()
              }}
            >
              <Arrow />
            </div>
            <a
              href="https://nova.global/"
              className="button grey-border button-global"
            >
              Global website
            </a>
          </div>
          <div className="menu__close" onClick={changeLocaleState}>
            <div className="menu__close-dash"></div>
            <div className="menu__close-dash"></div>
          </div>
        </div>
        <div className="langs__list ">
          {langs?.map((l: any, id: number) => (
            <div className="langs__section" key={id}>
              <div className="langs__section-title">{l.continent}</div>
              {l.list.map((li: any, i: number) => (
                <div
                  className={classNames(
                    'langs__col',
                    // li.country == GlobalState.currentLocale.country && 'active',
                  )}
                  key={i}
                >
                  <div className="langs__col-title"><img src={li.flag } alt=''/>{li.country}</div>
                  <div className="langs__col-row">
                    {li.langs.map((la: any, idx: number) => {
                      return (
                        <div
                          className={classNames(
                            'langs__col-text',
                            GlobalState.currentLocale.lang == la.title &&
                              GlobalState.currentLocale.country == li.country &&
                              'current',
                            !la.link?.length && 'disabled-link',
                          )}
                          key={idx}
                          onClick={() => {
                            if (
                              GlobalState.currentLocale.lang == la.title &&
                              GlobalState.currentLocale.country == li.country
                            )
                              return
                            if (li.country == 'Ukraine') {
                              changeLocale(la.title, li.country)
                            } else window.location.href = la.link
                          }}
                        >
                          <span>{la.title}</span>
                        </div>
                      )
                    })}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
})

export default LocaleMenu
